import { DataTableDetailUIModel } from "src/store/models/ui/dataTable/dataTableDetail";
import { DataTableSideUIModel } from "src/store/models/ui/dataTable/dataTableSide";
import { DataTableTableUIModel } from "src/store/models/ui/dataTable/dataTableTable";

export const encooDataTableUIModels = {
  dataTableTable: DataTableTableUIModel,
  dataTableSide: DataTableSideUIModel,
  dataTableDetail: DataTableDetailUIModel,
};
